export default function MoreButton({ children, ...otherProps }) {
  return (
    <button className="flex items-center justify-center bg-white border-2 border-onbg 
      h-[3.125rem] py-2 px-[1.875rem] rounded-md text-sm font-semibold relative 
      before:absolute before:h-full before:left-0 before:top-0 before:bg-primary 
      before:w-0 hover:before:w-full before:transition-all before:duration-300 transition-all 
      duration-300 hover:text-white outline-none hover:border-primary cursor-pointer" {...otherProps}>
      <span className="z-10">{children}</span>
    </button>
  );
}
